<div *ngIf="displayType === 'float'" class="xn-field-float">
  <div *ngIf="type !== 'select' && type !== 'date'" class="p-float-label {{styleClass}}" [class.field-invalid]="shouldDisplayErrors()">
    <input 
      [type]="type" 
      [id]="name" 
      [name]="$any(name)" 
      pInputText 
      [(ngModel)]="_value" 
      (ngModelChange)="_onValueChange($event)" 
      class="w-full" 
      [required]="$any(required)"
      [autocomplete]="autocomplete"
    />
    <label for="{{name}}">{{getDisplayLabel() | translate}}<span class="xn-field-required-mark" *ngIf="required">*</span></label>
  </div>
  
  <div *ngIf="type === 'select'" class="p-float-label {{styleClass}}" [class.field-invalid]="shouldDisplayErrors()">
    <xn-dropdown 
      [autoDisplayFirst]="autoDisplayFirst" 
      [id]="name" 
      [name]="$any(name)" 
      [options]="selectOptions" 
      [(ngModel)]="_value" 
      (ngModelChange)="_onValueChange($event)" 
      [optionLabel]="optionLabel" 
      [optionValue]="optionValue"
      styleClass="w-full"></xn-dropdown>
    <label for="{{name}}">{{getDisplayLabel() | translate}}<span *ngIf="required">*</span></label>
  </div>
  
  <div *ngIf="type === 'date'" class="p-float-label {{styleClass}}" [class.field-invalid]="shouldDisplayErrors()">
    <p-calendar 
      [dateFormat]="dateFormat" 
      styleClass="w-full"
      inputStyleClass="w-full" 
      [id]="name" 
      [name]="$any(name)" 
      [(ngModel)]="this._value" 
      (ngModelChange)="_onValueChange($event)" 
      [minDate]="$any(minDate)"
      [maxDate]="$any(maxDate)"
      appendTo="body"
    ></p-calendar>
  
    <label for="{{name}}">{{getDisplayLabel() | translate}}<span *ngIf="required">*</span></label>
  </div>
  
  <!-- display error -->
  <small class="field-error-message" *ngIf="shouldDisplayErrors()">{{getError() | translate}}</small>
</div>

<!-- display normal -->
<div *ngIf="displayType === 'normal'" class="xn-field">
  <div *ngIf="type !== 'select' && type !== 'date' && type !== 'checkbox' && type !== 'password' && type !== 'file' && type !== 'time' && type !== 'phone' && type !== 'switch'" class="xn-text-field field {{styleClass}}" [class.field-invalid]="shouldDisplayErrors()">
    <label 
      for="{{name}}"
      *ngIf="!hideLabel"
    >{{getDisplayLabel() | translate}}<span  class="xn-field-required-mark" *ngIf="required">*</span></label>
    <input 
      [type]="getFieldType()" 
      [id]="name" 
      [name]="$any(name)" 
      pInputText 
      [(ngModel)]="_value" 
      (ngModelChange)="_onValueChange($event)" 
      class="w-full" 
      [required]="$any(required)"
      placeholder="{{getPlaceholder() | translate}}"
      [autocomplete]="autocomplete"
      [readonly]="readonly"
      [disabled]="$any(disabled)"
      #formControl
    />
  </div>

  <div *ngIf="type === 'phone'" class="xn-text-field field {{styleClass}}" [class.field-invalid]="shouldDisplayErrors()"
  >
  <label 
      for="{{name}}"
      *ngIf="!hideLabel"
    >{{getDisplayLabel() | translate}}<span  class="xn-field-required-mark" *ngIf="required">*</span></label>

    <app-input-phone
      [id]="name"
      [(ngModel)]="_value" 
      (ngModelChange)="_onValueChange($event)" 
      class="w-full" 
      [name]="$any(name)"
      [readonly]="readonly"
      [disabled]="$any(disabled)"
    >
    </app-input-phone>

</div>

  <div *ngIf="type === 'password'" class="xn-text-field field {{styleClass}}" [class.field-invalid]="shouldDisplayErrors()">
    <label for="{{name}}">{{getDisplayLabel() | translate}}<span class="xn-field-required-mark" *ngIf="required">*</span></label>

    <p-password 
      [id]="name" 
      [name]="$any(name)" 
      [(ngModel)]="_value" 
      (ngModelChange)="_onValueChange($event)" 
      class="w-full" 
      styleClass="w-full"
      [required]="$any(required)"
      placeholder="{{getPlaceholder() | translate}}"
      [toggleMask]="passwordToggleMask"
      [feedback]="$any(passwordFeedback)"
      [disabled]="$any(disabled)"
    >
    </p-password>

    <div class="mt-2" *ngIf="!hidePasswordHints">
      <ul class="text-[12px] p-0 list-inside list-none rules">
        <li *ngFor="let rule of passwordRules">
          <span class="rule-status" [class.rule-status-success]="rule.status"></span>
          <span *ngIf="rule.message">{{rule.message | translate}}</span>
        </li>
      </ul>
    </div>
  </div>
  
  <div *ngIf="type === 'select'" class="xn-select-field field {{styleClass}}" [class.field-invalid]="shouldDisplayErrors()">
    <label for="{{name}}">{{getDisplayLabel() | translate}}<span class="xn-field-required-mark" *ngIf="required">*</span></label>
    <xn-dropdown 
      *ngIf="!translateOptions"
      [autoDisplayFirst]="autoDisplayFirst" 
      [id]="name" 
      [name]="$any(name)" 
      [options]="selectOptions" 
      [(ngModel)]="_value" 
      (ngModelChange)="_onValueChange($event)" 
      [optionLabel]="optionLabel" 
      [optionValue]="optionValue"
      placeholder="{{getPlaceholder() | translate}}"
      [disabled]="$any(disabled)"
      [readonly]="readonly"
      appendTo="body"
      styleClass="w-full"></xn-dropdown>

      <xn-dropdown 
        *ngIf="translateOptions"
        [autoDisplayFirst]="autoDisplayFirst" 
        [id]="name" 
        [name]="$any(name)" 
        [options]="selectOptions" 
        [(ngModel)]="_value" 
        (ngModelChange)="_onValueChange($event)" 
        [optionLabel]="optionLabel" 
        [optionValue]="optionValue"
        placeholder="{{getPlaceholder() | translate}}"
        [disabled]="$any(disabled)"
        [readonly]="readonly"
        appendTo="body"
        styleClass="w-full">

        <ng-template pTemplate="selectedItem" let-selectedItem>
          {{selectedItem[optionLabel || ''] | translate}}
        </ng-template>
        <ng-template let-item pTemplate="item">
          {{item[optionLabel || ''] | translate}}
        </ng-template>
      </xn-dropdown>
        
  </div>
  
  <div *ngIf="type === 'date'" class="xn-date-field field {{styleClass}}" [class.field-invalid]="shouldDisplayErrors()">
    <label for="{{name}}">{{getDisplayLabel()| translate}}<span class="xn-field-required-mark" *ngIf="required">*</span></label>
    <p-calendar 
      [dateFormat]="dateFormat" 
      styleClass="w-full"
      inputStyleClass="w-full" 
      [id]="name" 
      [name]="$any(name)" 
      [(ngModel)]="this._value" 
      (ngModelChange)="_onValueChange($event)" 
      [minDate]="$any(minDate)"
      [maxDate]="$any(maxDate)"
      [showIcon]="true"
      [readonlyInput]="readonly"
      [disabled]="$any(disabled)"
      placeholder="{{getPlaceholder() | translate}}"
      [view]="$any(calendarView)"
      appendTo="body"
    ></p-calendar>
  </div>

  <div *ngIf="type === 'time'" class="xn-date-field field {{styleClass}}" [class.field-invalid]="shouldDisplayErrors()">
    <label for="{{name}}">{{getDisplayLabel()| translate}}<span class="xn-field-required-mark" *ngIf="required">*</span></label>
    <p-calendar 
      [dateFormat]="dateFormat" 
      styleClass="w-full"
      inputStyleClass="w-full" 
      [id]="name" 
      [name]="$any(name)" 
      [(ngModel)]="this._value" 
      (ngModelChange)="_onValueChange($event)" 
      [minDate]="$any(minDate)"
      [maxDate]="$any(maxDate)"
      [showIcon]="true"
      [timeOnly]="true"
      hourFormat="12"
      icon="pi pi-clock"
      placeholder="{{getPlaceholder() | translate}}"
      appendTo="body"
    ></p-calendar>
  </div>

  <div *ngIf="type === 'checkbox'" class="xn-checkbox-field field-checkbox">
    <xn-checkbox 
      [binary]="true" 
      [(ngModel)]="this._value" 
      (ngModelChange)="_onValueChange($event)" 
      [name]="$any(name)"
      [disabled]="$any(disabled)"
      [inputId]="name"></xn-checkbox>

    <label for="{{name}}" id="{{name}}-label">{{getDisplayLabel()| translate}}</label>
  </div>

  <div *ngIf="type === 'switch'" class="xn-text-field field {{styleClass}}">
    <label for="{{name}}" id="{{name}}-label">{{getDisplayLabel()| translate}}</label>
    <p-inputSwitch 
      [(ngModel)]="this._value" 
      (ngModelChange)="_onValueChange($event)" 
      [name]="$any(name)"
      [disabled]="$any(disabled)"
      [id]="name"></p-inputSwitch>
  </div>

  <div *ngIf="type === 'file'" 
    class="xn-file-field"
    [class.xn-field-disabled]="disabled"
  >
    <label for="{{name}}">{{getDisplayLabel() | translate}}<span  class="xn-field-required-mark" *ngIf="required">*</span></label>
    <div class="xn-file-field-input">
      <span *ngIf="!_value">{{(fileButtonText || 'common.browse') | translate}}</span>
      <span *ngIf="_value && _value.file && _value.file.name">{{_value.file.name}}</span>
      <input 
        type="file" 
        [name]="$any(name)" 
        #fileInput
        (change)="onFileChanged($event)" 
        [accept]="fileAccept"
        [disabled]="$any(disabled)"
      >
    </div>
    <div *ngIf="fileHint" class="mt-2">{{fileHint}}</div>
    <div *ngIf="fileHintHtml" class="mt-2" [innerHTML]="fileHintHtml"></div>
    <div *ngIf="fileHintHtmlTranslate" class="mt-2" [innerHTML]="fileHintHtmlTranslate | translate"></div>
  </div>
  
  <!-- display error -->
  <small class="field-error-message" *ngIf="shouldDisplayErrors()">{{getError() | translate}}</small>
</div>